export class AnswerToCreateOrderRequest {
    customerOrderReference?: string;
    //totalPrice?: number;
}
